'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var Common;
(function (Common) {
    var aTag = /** @class */ (function () {
        function aTag() {
            var _this = this;
            this.disabled = false;
            var self = this;
            var hash = location.hash;
            if (hash) {
                $('body, html').stop().scrollTop(0);
                setTimeout(function () {
                    self.scrollToAnker(hash);
                }, 100);
            }
            $('a').click(function (e) {
                _this.set($(e.currentTarget));
                if (_this.disabled) {
                    return false;
                }
                else {
                    return _this.smoothScroll();
                }
            });
        }
        aTag.prototype.scrollToAnker = function (hash) {
            var target = $(hash);
            var position = target.offset().top;
            $('body, html').stop().animate({ scrollTop: position }, 500);
        };
        aTag.prototype.set = function (el) {
            this.el = el;
            this.href = el.attr("href");
            this.disabled = el.attr("disabled") == "disabled";
        };
        aTag.prototype.smoothScroll = function () {
            var href = this.href ? this.href : '';
            if (href != '#') {
                if (href.match(/^#/)) {
                    var target = $(href == "" ? 'html' : href);
                    var position = target.offset().top;
                    if (this.el.attr("data-no-anime") == "1") {
                        var speed = 0;
                        $("html, body").animate({ scrollTop: position }, speed, "linear");
                    }
                    else {
                        var speed = 500;
                        $("html, body").animate({ scrollTop: position }, speed, "swing");
                    }
                    return false;
                }
                else {
                    return true;
                }
            }
            else {
                return false;
            }
        };
        return aTag;
    }());
    Common.aTag = aTag;
})(Common || (Common = {}));
exports.default = Common;
